import { CorporateContactEditForm } from 'application/corporate/forms';
import { BaseEditViewStore } from 'core/stores';
import { CorporateContactService } from 'application/corporate/services';
import { action, observable } from 'mobx';
import _ from 'lodash';
import { BaasicDropdownStore } from 'core/stores';
import { ContactDepartmentService } from 'application/contact-department/services';
import { emailRecipientLabels } from 'core/utils';

class CorporateContactEditViewStore extends BaseEditViewStore {
    @observable accessor facilities = [];
    @observable accessor disabledFacilities = [];
    @observable accessor displayFacilities = false;

    constructor(rootStore, componentParams) {
        const corporateId = rootStore.routerStore.routerState.params.id;
        const service = new CorporateContactService(rootStore.application.baasic.apiClient);
        const contact = componentParams.modalParams.data.item;
        super(rootStore, {
            name: 'corporate-contact',
            id: contact != undefined ? contact.id : null,
            Form: CorporateContactEditForm,
            actions: () => {
                return {
                    get: async (id, opts) => {
                        opts = {...opts, embed: "CorporateContactContactDepartments,CorporateContactFacilities"};
                        const response = await service.get(id, opts);

                        this.facilities = response.data.corporateContactFacilities;
                        this.facilities && this.facilities.filter(f => !f.isEnabled).map(f => {
                                this.disabledFacilities.push(f.id);
                        }).sort((a, b) => a.name.localeCompare(b.name));

                        return {...response.data, corporateContactDepartments: response.data.corporateContactContactDepartments.map(cc => cc.contactDepartment )};
                    },
                    update: async (resource) => {
                        if (resource.deliveryTicketType === 'To'){
                            resource.deliveryTicketType = 'CC';
                            rootStore.notificationStore.error("Corporate contacts can only be copied on the Delivery Ticket. The delivery ticket can only be sent “To” a facility contact. Emails setting updated to “CC”.");
                        }
                        const response = await service.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        if (resource.deliveryTicketType === 'To'){
                            resource.deliveryTicketType = 'CC';
                            rootStore.notificationStore.error("Corporate contacts can only be copied on the Delivery Ticket. The delivery ticket can only be sent “To” a facility contact. Emails setting updated to “CC”.");
                        }
                        const response = await service.create(_.extend(resource, {corporateId: corporateId}));
                        return response.data;
                    }
                }
            },
            
            FormClass: CorporateContactEditForm,
        });

        this.facilities = componentParams.modalParams.data.facilities && componentParams.modalParams.data.facilities.sort((a, b) => a.name.localeCompare(b.name));
        this.contacts = componentParams.modalParams.data.contacts;

        this.componentParams = componentParams;
        this.createContactDepartmentStore();
    } 

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;
        resource.contactDepartmentIds = resource.corporateContactDepartments && resource.corporateContactDepartments.map(i => { return i.id });

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.id,
                disabledCorporateContactFacilityIds: this.disabledFacilities,
                ...resource
            });

            this.form.setFieldsDisabled(false);
            this.componentParams.modalParams.data.onSuccess();
            await setTimeout(() => this.rootStore.notificationStore.success("Contact successfully updated."));
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;
        resource.contactDepartmentIds = resource.corporateContactDepartments && resource.corporateContactDepartments.map(i => { return i.id });

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create({...resource, disabledCorporateContactFacilityIds: this.disabledFacilities});

            this.form.setFieldsDisabled(false);
            this.componentParams.modalParams.data.onSuccess();
            await setTimeout(() => this.rootStore.notificationStore.success("Contact successfully added."));
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onCreateError(err);
        }
    }

    createContactDepartmentStore(){
        const contactDepartmentService = new ContactDepartmentService(this.rootStore.application.baasic.apiClient);  
        this.contactDepartmentStore = new BaasicDropdownStore({ multi: true, filterable: true }, {
			fetchFunc: async (term) => {
				const response = await contactDepartmentService.find({ searchQuery: term, rpp: 50, embed: "ContactDepartmentType" });
				return response.data.item.filter(x=> x.contactDepartmentType && x.contactDepartmentType.name == "Corporate Contact");
			},
            onChange: () => { this.setEmailSettings() }
		});
    }

    @action.bound
    handleDisabledFacility(id) {
        const index = this.disabledFacilities.indexOf(id);
        if (index > -1) {
            this.disabledFacilities.splice(index, 1);
        } else {
            this.disabledFacilities.push(id);
        }
    }

    @action.bound
    setDisplayFacilities() {
        this.displayFacilities = !this.displayFacilities;
    }

    @action.bound
    setEmailSettings() {
        let selectedDepartments = this.form.$("corporateContactDepartments").value;
        let emailOptionValues = { "To": 2, "CC": 1, "": 0 };

        emailRecipientLabels.forEach(emailSetting => {
            if (selectedDepartments.length === 0){
                this.form.$(emailSetting.name).set("");
                return;
            }

            let allDepartmentValue = selectedDepartments.map(d => d[emailSetting.name]); 
            let settingValue = allDepartmentValue.reduce(function(i, j) {
                return emailOptionValues[i] > emailOptionValues[j] ? i : j;
            });

            this.form.$(emailSetting.name).set(settingValue);
        });
    }

}

export default CorporateContactEditViewStore;